import page1 from "../../../assets/images/story/page1.png";
import page2 from "../../../assets/images/story/page2.png";

export default function FlipBook({
  rotateY,
  fillHeight = false,
}: {
  rotateY: number;
  fillHeight?: boolean;
}) {
  const imgClass = fillHeight
    ? "h-full w-full max-w-none rounded-bl-lg rounded-tl-lg object-fill"
    : "rounded-bl-lg rounded-tl-lg";

  return (
    <div
      className="flip-container"
      style={
        fillHeight
          ? { width: "auto", height: "100%", aspectRatio: "700 / 420" }
          : undefined
      }
    >
      <div className="flip-page" id="first">
        <div className="flip-back">
          <div className="flip-outer">
            <div className="flip-content">
              <img src={page1} alt="page1" className={imgClass} />
            </div>
          </div>
        </div>
      </div>
      <div
        className="flip-page"
        id="second"
        style={{
          transform: `rotateY(${rotateY}deg)`,
        }}
      >
        <div className="flip-front">
          <div className="flip-outer">
            <div className="flip-content">
              <img src={page1} alt="page1" className={imgClass} />
            </div>
          </div>
        </div>
        <div className="flip-back" id="third">
          <div className="flip-outer">
            <div
              className="flip-content"
              style={fillHeight ? { width: "200%" } : undefined}
            >
              <div className="helper-class-to-make-bug-visbile">
                <img src={page2} alt="page2" className={imgClass} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flip-page" id="fourth">
        <div className="flip-front">
          <div className="flip-outer">
            <div className="flip-content">
              <img src={page2} alt="page2" className={imgClass} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
